/*
 * Search actions
 */

export const OPSLAG = 'DFIM_OPSLAG';
export const OPSLAG_SUCCESS = 'DFIM_OPSLAG_SUCCESS';
export const OPSLAG_ERROR = 'DFIM_OPSLAG_ERROR';

export const opslag = (input) => ({ type: OPSLAG, payload: input });
export const opslagSuccess = (data) => ({ type: OPSLAG_SUCCESS, payload: data });
export const opslagError = (error) => ({ type: OPSLAG_ERROR, error: error });

export const DAWA_LOOKUP = 'DAWA_LOOKUP';
export const DAWA_LOOKUP_SUCCES = 'DAWA_LOOKUP_SUCCESS';
export const DAWA_LOOKUP_ERROR = 'DAWA_LOOKUP_ERROR';

export const dawaLookup = (input) => ({ type: DAWA_LOOKUP, payload: input });
export const dawaLookupSuccess = (data) => ({ type: DAWA_LOOKUP_SUCCES, payload: data });
export const dawaLookupError = (error) => ({ type: DAWA_LOOKUP_ERROR, error: error });
